// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "scrollBody-1KjEp";
var _3 = "modal-1-H6U";
var _4 = "closeIcon-te75K";
var _5 = "warningModal_header-3HRK0";
export { _1 as "__esModule", _2 as "scrollBody", _3 as "modal", _4 as "closeIcon", _5 as "warningModal_header" }
export default { "__esModule": _1, "scrollBody": _2, "modal": _3, "closeIcon": _4, "warningModal_header": _5 }
